import React, { useEffect, useState } from "react";
import { GithubIcon, LinkedinIcon, Mail } from "lucide-react";
import gsap from "gsap";
// import "../css/Button.css";

function Hero() {
  const [name, setName] = useState(".");
  const fullName = "Nishan Suwal.";

  useEffect(() => {
    let tl = gsap.timeline();

    function runAnimation() {
      // Clear previous animation before restarting
      tl.clear();
      setName("."); // Reset text before animation starts

      // Animate text letter by letter
      fullName.split("").forEach((char, index) => {
        tl.to({}, { duration: 0.2 }).call(() => setName((prev) => prev + char));
      });

      // Restart animation after 3s
      tl.to({}, { duration: 3 }).call(runAnimation);
    }

    runAnimation();

    return () => tl.kill(); // Cleanup animation when component unmounts
  }, []);

  return (
    <section
      id="home"
      className="min-h-screen flex items-center justify-center relative overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-blue-50 to-teal-50 dark:from-gray-900 dark:to-gray-800 -z-10" />

      <div className="container mx-auto px-4 py-32 flex flex-col items-center text-center">
        {/* Profile Image */}
        <div className="w-56 h-56 rounded-full overflow-hidden mb-8 ring-4 ring-blue-500 ring-offset-4 dark:ring-offset-gray-900">
          <img
            src="/potfolios.png"
            alt="nishan suwal"
            className="w-full h-full object-cover"
          />
        </div>

        {/* Animated Name */}
        <h1 className="text-5xl md:text-6xl font-bold mb-6 bg-gradient-to-r from-blue-600 to-teal-400 bg-clip-text text-transparent">
          {name}
        </h1>

        {/* Description */}
        <p className="text-xl md:text-2xl text-gray-600 dark:text-gray-300 mb-8 max-w-2xl">
          Full Stack Developer specializing in modern web technologies. Building
          beautiful, responsive, and user-friendly applications.
        </p>

        {/* Social Links */}
        <div className="flex gap-4 mb-12">
          <a
            href="https://github.com/nishansuwal"
            target="_blank"
            rel="noopener noreferrer"
            className="p-3 rounded-full bg-gray-100 dark:bg-gray-800 hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors"
          >
            <GithubIcon color="black" size={32} className="w-6 h-6" />
          </a>
          <a
            href="https://www.linkedin.com/in/nishan-suwal/"
            target="_blank"
            rel="noopener noreferrer"
            className="p-3 rounded-full bg-gray-100 dark:bg-gray-800 hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors"
          >
            <LinkedinIcon className="w-6 h-6" />
          </a>
          <a
            href="#contact"
            className="p-3 rounded-full bg-gray-100 dark:bg-gray-800 hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors"
          >
            <Mail className="w-6 h-6" />
          </a>
        </div>

        {/* Buttons */}
        <div className="flex flex-col sm:flex-row gap-4">
          <a
            href="#projects"
            className="px-8 py-3 rounded-full bg-blue-600 text-white hover:bg-blue-700 transition-colors"
          >
            View My Work
          </a>
          <a
            href="#contact"
            className="px-8 py-3 rounded-full bg-gray-100 dark:bg-gray-800 text-gray-900 dark:text-white hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors"
          >
            Contact Me
          </a>
        </div>
      </div>
    </section>
  );
}

export default Hero;



// import { useEffect, useRef } from "react";
// import gsap from "gsap";
// import { ScrollTrigger } from "gsap/ScrollTrigger";
// import "../css/Hero.css";

// const Hero = () => {
//   const heroRef = useRef(null);
//   const textRef = useRef(null);
//   const imgRef = useRef(null);

//   useEffect(() => {
//     gsap.registerPlugin(ScrollTrigger);

//     // Fade-in & Slide-Up for text
//     gsap.fromTo(
//       textRef.current,
//       { opacity: 0, y: 50 },
//       { opacity: 1, y: 0, duration: 1.2, ease: "power3.out", delay: 0.5 }
//     );

//     // Image scale-in effect
//     gsap.fromTo(
//       imgRef.current,
//       { opacity: 0, scale: 0.8 },
//       { opacity: 1, scale: 1, duration: 1.5, ease: "power3.out", delay: 0.8 }
//     );
//   }, []);

//   return (
//     <section className="hero" ref={heroRef}>
//       <div className="hero__content" ref={textRef}>
//         <h1 className="hero__title">Nishan Suwal</h1>
//         <p className="hero__subtitle">
//           Full Stack Developer specializing in modern web technologies. Building
//           beautiful, responsive, and user-friendly applications.
//         </p>
//         <button className="hero__button">Explore</button>
//       </div>
//       <div className="hero__image-container">
//         <img
//           ref={imgRef}
//           src="/potfolios.png"
//           alt="Profile"
//           className="hero__image"
//         />
//       </div>
//     </section>
//   );
// };

// export default Hero;
